// SHOULD USE AUTO GENERATED API MODEL.

export enum BackendLogLevel {
	Error = 'Error',
	Debug = 'Debug',
	Info = 'Info',
}
